import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import StoreModal from "./StoreModal";
import DeleteStore from "./DeleteStore";

import { FormControl, OutlinedInput, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import { API_BASE_URL } from "../../../apiConfig";
import AddStore from "./AddStore.js";
import EditStore from "./EditStore";
import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import ManageCoupon from "../coupon/ManageCoupon.js";
import TelegramIcon from "@mui/icons-material/Telegram";
import GoogleIcon from "@mui/icons-material/Google";
import SEO from "./SEO.js";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";

export default function ManageStore() {
  const [rows, setRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedStoreId, setSelectedStoreId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editSroreModalOpen, setEditStoreModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [triggerSearch, setTriggerSearch] = useState(false);
  const [addCarModalOpen, setAddCarModalOpen] = useState(false);

  const [showConfirm, setShowConfirm] = useState(false);
  const [storeIdToDelete, setStoreIdToDelete] = useState(null);
  const [nameToDelete, setNameToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOpenCoupon, setModalOpenCoupon] = useState(false);

  const [showConfirmSeo, setShowConfirmSeo] = useState(false);
  const [storeIdToSeo, setStoreIdToSeo] = useState(null);
  const [nameToSeo, setNameToSeo] = useState(null);

  const [refreshFlag, setRefreshFlag] = useState(false);

  const fetchData = async (page, searchQuery) => {
    const token = localStorage.getItem("token");

    if (!token) {
      throw new Error("Token not available. Please log in.");
    }

    try {
      const response = await axios.get(
        `${API_BASE_URL}Store/GetAllByPage/${page + 1}/${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.store && response.data.store.length > 0) {
        const formattedData = response.data.store.map((store) => ({
          id: store.id,
          storeTitle: store.storeTitle,
          storeDescription: store.storeDescription,
          storesImagePath: store.storesImagePath,
          slug: store.slug,
          storeName: store.storeName,
          metaDescription: store.metaDescription,
          visitCount: store.visitCount,
        }));

        setRows(formattedData);
        setTotalRecords(response.data.allRecord);
      } else {
        setRows([]);
        setTotalRecords(0);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        try {
          const newToken = await refreshTokenIfNeeded();

          if (!newToken) {
            return navigate("/", { replace: true });
          }

          // إعادة الطلب بالتوكن الجديد
          const response = await axios.get(
            `${API_BASE_URL}Store/GetAllByPage/${page + 1}/${searchQuery}`,
            {
              headers: {
                Authorization: `Bearer ${newToken}`,
              },
            },
          );

          if (response.data.store && response.data.store.length > 0) {
            const formattedData = response.data.store.map((store) => ({
              id: store.id,
              storeTitle: store.storeTitle,
              storeDescription: store.storeDescription,
              storesImagePath: store.storesImagePath,
              slug: store.slug,
              storeName: store.storeName,
              metaDescription: store.metaDescription,
              visitCount: store.visitCount,
            }));

            setRows(formattedData);
            setTotalRecords(response.data.allRecord);
          } else {
            setRows([]);
            setTotalRecords(0);
          }
        } catch (retryError) {
          setRows([]);
          setTotalRecords(0);
        }
      } else {
        setRows([]);
        setTotalRecords(0);
      }
    }
  };

  const handlePaginationChange = (paginationModel) => {
    setCurrentPage(paginationModel.page);
  };

  const handleSearch = () => {
    //setCurrentPage(0);
    setTriggerSearch(!triggerSearch);
  };

  const handleClear = () => {
    setSearchValue("");
    //setCurrentPage(0);
    setTriggerSearch(!triggerSearch);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  // useEffect(() => {
  //   fetchData(currentPage, searchValue);
  // });

  useEffect(() => {
    fetchData(currentPage, searchValue);
  }, [currentPage, triggerSearch, refreshFlag]);

  const handleDeleteClick = (id, storeTitle) => {
    setStoreIdToDelete(id);
    setNameToDelete(storeTitle);
    setShowConfirm(true);
    // fetchData(currentPage, searchValue);
  };

  const handleConfirmDelete = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.delete(`${API_BASE_URL}Store/Delete/${storeIdToDelete}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      alert("تم حذف المتجر بنجاح.");
      setShowConfirm(false);
      setStoreIdToDelete(null);
      fetchData(currentPage, searchValue);
    } catch (error) {
      if (error.response?.status === 401) {
        try {
          const newToken = await refreshTokenIfNeeded();

          if (!newToken) {
            return navigate("/", { replace: true });
          }

          // إعادة الطلب بالتوكن الجديد
          await axios.delete(`${API_BASE_URL}Store/Delete/${storeIdToDelete}`, {
            headers: {
              Authorization: `Bearer ${newToken}`,
            },
          });

          alert("تم حذف المتجر بنجاح.");
          setShowConfirm(false);
          setStoreIdToDelete(null);
          fetchData(currentPage, searchValue);
        } catch (retryError) {
          alert("حدث خطأ أثناء محاولة حذف المتجر.");
        }
      } else {
        alert("حدث خطأ أثناء محاولة حذف المتجر.");
      }
    }
  };

  const handleSeo = (id, storeTitle) => {
    setStoreIdToSeo(id);
    setNameToSeo(storeTitle);
    setShowConfirmSeo(true);
  };

  const handleConfirmSeo = async () => {
    const token = localStorage.getItem("token");

    try {
      setShowConfirmSeo(false);
      setIsLoading(true);

      const res = await axios.post(
        `${API_BASE_URL}SEO/ScanStore/${storeIdToSeo}`,
        null,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setIsLoading(false);
      alert("تم فحص وتحسين المتجر بنجاح.");
      setStoreIdToSeo(null);
      fetchData(currentPage, searchValue);
    } catch (error) {
      if (error.response?.status === 401) {
        try {
          const newToken = await refreshTokenIfNeeded();

          if (!newToken) {
            return navigate("/", { replace: true });
          }

          const res = await axios.post(
            `${API_BASE_URL}SEO/ScanStore/${storeIdToSeo}`,
            null,
            {
              headers: { Authorization: `Bearer ${newToken}` },
            },
          );

          setIsLoading(false);
          alert("تم فحص وتحسين المتجر بنجاح.");
          setStoreIdToSeo(null);
          fetchData(currentPage, searchValue);
        } catch (retryError) {
          setIsLoading(false);
          alert("حدث خطأ أثناء محاولة فحص وتحسين المتجر.");
        }
      } else {
        setIsLoading(false);
        alert("حدث خطأ أثناء محاولة فحص وتحسين المتجر.");
      }
    }
  };

  const refreshData = () => {
    // fetchData(currentPage, searchValue);
    setRefreshFlag((prev) => !prev);
  };
  const handleCancelDelete = () => {
    setShowConfirm(false);
    setStoreIdToDelete(null);
  };

  const handleCancelSeo = () => {
    setShowConfirmSeo(false);
    setStoreIdToSeo(null);
  };

  const handleView = (id) => {
    setSelectedStoreId(id);
    setModalOpen(true);
  };

  const handleViewManageCoupon = (id) => {
    setSelectedStoreId(id); // تعيين قيمة المتجر المحدد
    setModalOpenCoupon(true); // فتح النافذة
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedStoreId(null);
  };

  const handleAddRow = () => {
    setAddCarModalOpen(true);
  };

  const handleCloseAddCarModal = () => {
    //fetchData(currentPage, searchValue);
    refreshData();
    setAddCarModalOpen(false);
    // setSearchValue(searchValue || "");
  };

  const handleEdit = (id) => {
    setSelectedStoreId(id);
    setEditStoreModalOpen(true);
  };
  const handleCloseEditCarModal = () => {
    // fetchData(currentPage, searchValue);
    refreshData();
    setEditStoreModalOpen(false);
    // setSearchValue(searchValue || "");
    //fetchData(currentPage);
  };

  const handleCloseManageCoupon = () => {
    setModalOpenCoupon(false);
    setSelectedStoreId(null); // إعادة تعيين القيمة إلى null
  };

  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const handleVisitSlug = (slug) => {
    const url = `https://couponfirstorder.com/${slug}`;
    window.open(url, "_blank"); // "_blank" تعني نافذة جديدة
  };

  const columns = [
    {
      field: "actions",
      headerName: "الإجراءات",
      flex: 2.5,
      renderCell: (params) => (
        <>
          {/* <IconButton onClick={() => handleEdit(params.row.id)}>
            <DescriptionIcon sx={{ color: "#607D8B" }} />
          </IconButton> */}
          <IconButton
            color="error"
            onClick={() =>
              handleDeleteClick(params.row.id, params.row.storeTitle)
            }
          >
            <DeleteIcon />
          </IconButton>

          <IconButton onClick={() => handleEdit(params.row.id)}>
            <EditIcon sx={{ color: "green" }} />
          </IconButton>
          <IconButton color="primary" onClick={() => handleView(params.row.id)}>
            <VisibilityIcon />
          </IconButton>
          <IconButton onClick={() => handleViewManageCoupon(params.row.id)}>
            <PlaylistAddCheckCircleIcon sx={{ color: "#607D8B" }} />
          </IconButton>

          {/* <IconButton
            sx={{ color: "#4285f4" }}
            onClick={() => handleSeo(params.row.id, params.row.storeName)}
          >
            <GoogleIcon />
          </IconButton> */}

          <IconButton
            sx={{ color: "#5b5b5c" }}
            onClick={() => handleVisitSlug(params.row.slug)}
          >
            <TelegramIcon />
          </IconButton>
        </>
      ),

      headerAlign: "right",
      align: "right",
    },

    {
      field: "visitCount",
      headerName: "الزيارات",
      flex: 0.8,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "storeName",
      headerName: "اسم المتجر",
      flex: 1.2,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "metaDescription",
      headerName: "وصف الميتا",
      flex: 1.5,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => {
        const cleanText = stripHtml(params.row.metaDescription || "").substring(
          0,
          100,
        );
        return `${cleanText}...`;
      },
    },

    {
      field: "slug",
      headerName: "الرابط",
      flex: 1.5,
      headerAlign: "right",
      align: "right",
    },

    {
      field: "storeTitle",
      headerName: "اسم المتجر",
      flex: 5,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => {
        const text = params.value; // النص داخل الخلية
        const isArabic = /[\u0600-\u06FF]/.test(text); // التحقق إذا كان النص يحتوي على أحرف عربية
        const direction = isArabic ? "rtl" : "ltr"; // تحديد الاتجاه بناءً على النص

        return (
          <div
            style={{
              direction: direction,
              textAlign: direction === "rtl" ? "right" : "left",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {text}
          </div>
        );
      },
    },
    {
      field: "storesImagePath",
      headerName: "صورة المتجر",
      flex: 1,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: 100, // عرض المربع
            height: 50, // ارتفاع المربع
            overflow: "hidden",
            borderRadius: "5px",
            //  border: "1px solid #ccc", // إضافة حدود
          }}
        >
          <img
            src={params.value}
            alt="store"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </Box>
      ),
    },
  ];

  return (
    <div
      dir={"rtl"}
      style={{
        color: "white",
        maxWidth: "100%",
        maxHeight: "100%",
        fontFamily: "'Changa', sans-serif",
      }}
    >
      <h3>إدارة المتاجر - الكوبونات</h3>
      <div
        dir={"ltr"}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "7%",
        }}
      >
        <div dir="rtl" style={{ width: "50%" }}>
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <OutlinedInput
              placeholder="ابحث بأسم المتجر"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onKeyDown={handleKeyDown}
              sx={{
                color: "#5b5b5c",
                backgroundColor: "#fff",
                borderRadius: "4px",
                "& input": { color: "#303031" },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#5b5b5c",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#5b5b5c",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#0064b7",
                },
              }}
              endAdornment={
                <InputAdornment position="end">
                  {searchValue && (
                    <IconButton onClick={handleClear}>
                      <ClearIcon />
                    </IconButton>
                  )}
                  <IconButton onClick={handleSearch}>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1%",
          }}
        >
          <Button variant="contained" color="primary" onClick={handleAddRow}>
            اضف متجر
          </Button>
        </div>

        <Box
          sx={{
            height: "67%",
            width: "100%",
          }}
        >
          <DataGrid
            style={{ background: "#f3f3f3" }}
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 8,
                },
              },
            }}
            pageSizeOptions={[8]}
            paginationMode="server"
            rowCount={totalRecords}
            disableRowSelectionOnClick
            onPaginationModelChange={(model) => {
              setIsLoading(true); // عند بدء تحميل الصفحة، تفعيل حالة التحميل
              handlePaginationChange(model);
              setIsLoading(false); // إلغاء حالة التحميل بعد استرجاع البيانات
            }}
            disableColumnFilter={true}
            disableColumnSelector={true}
            disableColumnMenu={true}
            disableColumnSorting={true}
            autoHeight={true}
            localeText={{
              noRowsLabel: "",
            }}
            sx={{
              "& .MuiTablePagination-actions > button": {
                transform: "rotate(180deg)",
              },
              "& .MuiDataGrid-columnHeaders": {
                direction: "ltr",
                textAlign: "right",
              },
              "& .MuiDataGrid-cell": {
                direction: "ltr",
                textAlign: "right",
              },
              "& .MuiDataGrid-footerContainer": {
                justifyContent: "flex-start",
              },
              "& .MuiTablePagination-toolbar": {
                direction: "rtl",
              },
              "& .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus-within": {
                outline: "none",
              },
            }}
          />
        </Box>
        {modalOpen && (
          <StoreModal carId={selectedStoreId} onClose={handleCloseModal} />
        )}

        {showConfirmSeo && (
          <SEO
            onConfirm={handleConfirmSeo}
            onCancel={handleCancelSeo}
            storeTitle={nameToSeo}
          />
        )}

        {addCarModalOpen && (
          <AddStore onClose={handleCloseAddCarModal} onSubmit={fetchData} />
        )}

        {modalOpenCoupon && (
          <ManageCoupon
            storeId={selectedStoreId}
            onClose={handleCloseManageCoupon}
            //onSubmit={fetchData}
          />
        )}
        {editSroreModalOpen && (
          <EditStore
            storeId={selectedStoreId}
            onClose={handleCloseEditCarModal}
            onSubmit={fetchData}
          />
        )}
        {showConfirm && (
          <DeleteStore
            onConfirm={handleConfirmDelete}
            onCancel={handleCancelDelete}
            storeTitle={nameToDelete}
          />
        )}
      </div>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.75)", // أغمق من 0.6
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            pointerEvents: "auto", // السماح فقط للـ overlay
          }}
          onClick={(e) => e.stopPropagation()} // منع أي ضغطة تمر من خلاله
          onMouseDown={(e) => e.preventDefault()}
          onKeyDown={(e) => e.preventDefault()}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "4px solid #999",
              borderTop: "4px solid white",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          ></div>
          <p
            style={{
              color: "#fff",
              marginTop: "12px",
              fontFamily: "'Changa', sans-serif",
            }}
          >
            انتظر جاري البحث بقوقل وجلب نتائج ترتيب المنافسين!
          </p>
          <style>
            {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
          </style>
        </div>
      )}
    </div>
  );
}
